import isStringifiedNumber from '../isStringifiedNumber';
const getQueryParams = () => {
    const rawQuery = new URLSearchParams(window.location.search);
    const entries = rawQuery.entries();
    let config = {};
    for (let param of entries) {
        config = { ...config, [param[0]]: isStringifiedNumber(param[1]) ? +param[1] : param[1] };
    }
    return config;
};
export default getQueryParams;
//# sourceMappingURL=index.js.map